import axios, { AxiosInstance } from 'axios'
import { authHeader, clientIdParam, errorHandler } from './axios.interceptors'

export default function configAxios(baseURL?: string): AxiosInstance {
  //eslint-disable-next-line
  console.log(`Configuring axios for '${baseURL}'...`)
  const client = axios.create()
  client.defaults.params = {}
  client.defaults.validateStatus = () => true
  client.defaults.baseURL = baseURL
  client.interceptors.request.use(authHeader)
  client.interceptors.request.use(clientIdParam)
  client.interceptors.response.use(_ => _, errorHandler)
  return client
}
